import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatSAR, formatNumber, formatPct } from '@/lib/format';
import { cn } from '@/lib/utils';
import { JargonTip } from '@/components/shared/JargonTip';

export const KpiCard = ({ label, value, format = 'num', trend, hint, accent = false, icon: Icon, jargon }) => {
  const display = format === 'sar' ? formatSAR(value, { compact: value > 100000 }) : format === 'pct' ? formatPct(value) : formatNumber(value);
  const up = trend != null && trend >= 0;
  return (
    <div className={cn('surface-card p-4 flex flex-col gap-2.5 transition-shadow hover:shadow-lift', accent && 'ring-1 ring-primary/30')}>
      <div className="flex items-start justify-between">
        <p className="text-xs text-muted-foreground font-medium inline-flex items-center">
          {label}
          {jargon && <JargonTip>{jargon}</JargonTip>}
        </p>
        {Icon && <Icon className="h-4 w-4 text-primary" aria-hidden="true" />}
      </div>
      <p className="font-mono-num text-2xl font-semibold text-foreground tracking-tight">{display}</p>
      <div className="flex items-center justify-between">
        {trend != null ? (
          <span
            className={cn('inline-flex items-center gap-0.5 text-[11px] font-medium', up ? 'kpi-trend-up' : 'kpi-trend-down')}
            aria-label={`${up ? 'up' : 'down'} ${Math.abs(trend)} percent vs previous period`}
          >
            {up ? <TrendingUp className="h-3 w-3" aria-hidden="true" /> : <TrendingDown className="h-3 w-3" aria-hidden="true" />}
            {Math.abs(trend)}%
          </span>
        ) : <span />}
        {hint && <span className="text-[11px] text-muted-foreground truncate ml-2">{hint}</span>}
      </div>
    </div>
  );
};

export default KpiCard;
